import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./ui/utils";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Home, LayoutDashboard, Package, ShoppingCart, Truck, TrendingUp, BarChart3, Search, Users, Package2, Shield, Zap, Palette, Smartphone, Workflow, X, } from "lucide-react";
const tabs = [
    {
        id: "dashboard",
        label: "Dashboard",
        icon: LayoutDashboard,
        hasCount: false,
    },
    {
        id: "general-addons",
        label: "General Addons",
        icon: Home,
        hasCount: true,
    },
    {
        id: "product-addons",
        label: "Product Addons",
        icon: Package,
        hasCount: true,
    },
    {
        id: "cart-checkout-addons",
        label: "Cart & Checkout",
        icon: ShoppingCart,
        hasCount: true,
    },
    {
        id: "shipping-payment",
        label: "Shipping & Payment",
        icon: Truck,
        hasCount: true,
    },
    {
        id: "marketing-sales",
        label: "Marketing & Sales",
        icon: TrendingUp,
        hasCount: true,
    },
    {
        id: "seo-performance",
        label: "SEO & Performance",
        icon: Search,
        hasCount: true,
    },
    {
        id: "customer-management",
        label: "Customer Management",
        icon: Users,
        hasCount: true,
    },
    {
        id: "inventory-management",
        label: "Inventory Management",
        icon: Package2,
        hasCount: true,
    },
    {
        id: "security-compliance",
        label: "Security & Compliance",
        icon: Shield,
        hasCount: true,
    },
    {
        id: "integrations-api",
        label: "Integrations & API",
        icon: Zap,
        hasCount: true,
    },
    {
        id: "content-design",
        label: "Content & Design",
        icon: Palette,
        hasCount: true,
    },
    {
        id: "mobile-apps",
        label: "Mobile & Apps",
        icon: Smartphone,
        hasCount: true,
    },
    {
        id: "automation-workflows",
        label: "Automation & Workflows",
        icon: Workflow,
        hasCount: true,
    },
    {
        id: "reports-analytics",
        label: "Reports & Analytics",
        icon: BarChart3,
        hasCount: true,
    },
    // {
    //   id: "free-addons",
    //   label: "Free Addons",
    //   icon: Gift,
    //   hasCount: true,
    // },
    // {
    //   id: "custom-requests",
    //   label: "Custom Development",
    //   icon: Code2,
    //   hasCount: false,
    // },
    // {
    //   id: "license-updates",
    //   label: "License & Updates",
    //   icon: Settings,
    //   hasCount: false,
    // },
    // {
    //   id: "help-docs",
    //   label: "Help & Documentation",
    //   icon: HelpCircle,
    //   hasCount: false,
    // },
];
export function AdminSidebar({ activeTab, onTabChange, addons = {}, isMobile = false, onClose, }) {
    const getAddonCount = (tabId) => {
        var _a;
        return ((_a = addons[tabId]) === null || _a === void 0 ? void 0 : _a.length) || 0;
    };
    return (_jsxs("div", { className: "w-70 bg-card border-r border-border h-full flex flex-col flex-shrink-0 transition-colors duration-300 overflow-hidden", children: [_jsx("div", { className: "p-6 border-b border-border flex-shrink-0", children: _jsxs("div", { className: "flex items-center gap-3 relative", children: [isMobile && onClose && (_jsx(Button, { variant: "ghost", size: "icon", className: "absolute -top-2 -right-2 w-8 h-8", onClick: onClose, children: _jsx(X, { className: "w-4 h-4" }) })), _jsx("div", { className: "w-10 h-10 speedpress-gradient rounded-lg flex items-center justify-center shadow-lg speedpress-logo-animate group cursor-pointer relative overflow-hidden", children: _jsx("span", { className: "text-white font-bold text-lg group-hover:scale-125 transition-all duration-500 relative z-10 drop-shadow-sm", children: "SP" }) }), _jsxs("div", { children: [_jsx("h1", { className: "font-semibold text-lg", style: { fontSize: "1.125rem", margin: '0px' }, children: "SpeedPress" }), _jsx("p", { className: "text-sm text-muted-foreground", style: { margin: '0px' }, children: "WooCommerce Suite" })] })] }) }), _jsx("nav", { className: "flex-1 py-4 overflow-y-auto custom-scrollbar", children: _jsx("div", { id: "sidebar-categories", className: "px-3 space-y-1", children: tabs.map((tab) => {
                        const Icon = tab.icon;
                        const addonCount = getAddonCount(tab.id);
                        return (_jsxs("button", { onClick: () => onTabChange(tab.id), style: { textAlign: "left" }, className: cn("w-full flex items-center justify-between gap-3 px-3 py-2.5 rounded-lg transition-all duration-200 text-sm transform hover:scale-[1.02]", activeTab === tab.id
                                ? "bg-primary text-primary-foreground shadow-md"
                                : "hover:bg-accent text-foreground hover:text-accent-foreground"), children: [_jsxs("div", { className: "flex items-center gap-3", children: [_jsx(Icon, { className: "w-4 h-4" }), _jsx("span", { children: tab.label })] }), tab.hasCount && addonCount > 0 && (_jsx(Badge, { variant: activeTab === tab.id
                                        ? "secondary"
                                        : "outline", className: cn("ml-auto text-xs px-2 py-0.5 h-5", activeTab === tab.id
                                        ? "bg-primary-foreground/20 text-primary-foreground border-primary-foreground/30"
                                        : "bg-accent text-accent-foreground"), children: addonCount }))] }, tab.id));
                    }) }) }), _jsx("div", { className: "p-3 border-t border-border flex-shrink-0", children: _jsx("div", { className: "text-xs text-muted-foreground text-center", children: "Version 1.0.0" }) })] }));
}
